import { render, staticRenderFns } from "./DropdownOptionsOptmized.vue?vue&type=template&id=8715cac8&scoped=true"
import script from "./DropdownOptionsOptmized.vue?vue&type=script&lang=ts"
export * from "./DropdownOptionsOptmized.vue?vue&type=script&lang=ts"
import style0 from "./DropdownOptionsOptmized.vue?vue&type=style&index=0&id=8715cac8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715cac8",
  null
  
)

export default component.exports